import { render, staticRenderFns } from "./GeometricAreaModelsViz.vue?vue&type=template&id=6bd96524&scoped=true"
import script from "./GeometricAreaModelsViz.vue?vue&type=script&lang=js"
export * from "./GeometricAreaModelsViz.vue?vue&type=script&lang=js"
import style0 from "./GeometricAreaModelsViz.vue?vue&type=style&index=0&id=6bd96524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd96524",
  null
  
)

export default component.exports